"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionResult = exports.Suggestion = exports.AutoSuggestionApi = void 0;
const tslib_1 = require("tslib");
const app_1 = require("app");
const json2typescript_1 = require("json2typescript");
const UtilService_1 = require("../../UtilService");
const Search_utils_1 = require("../Search.utils");
class AutoSuggestionApi extends app_1.BaseApi {
    constructor(config) {
        super(config);
        this.buildAutoSuggestionUrl = (endPoint, params) => {
            return `${endPoint}?${this.buildAutoSuggestionQuery(params)}`;
        };
        this.mapSuggestionToSearchOption = (data) => ({
            query: data.term,
            term: data.highlightedTerm ? data.highlightedTerm : data.term,
        });
    }
    getData(params) {
        if (!this.config.autoSuggestionEnabled) {
            return Promise.reject('Auto suggestions is disabled. BadRequest occured');
        }
        return super.getData(params).then(data => {
            const jsonConvert = new json2typescript_1.JsonConvert();
            const suggestionResult = jsonConvert.deserialize(data, SuggestionResult);
            return this.convertApiResultToUI(suggestionResult);
        });
    }
    buildAutoSuggestionQuery(params) {
        const builder = new Search_utils_1.SearchParamsBuilder();
        //add additonal symbols "" to avoidd 500 error
        const valueConverterForQuery = value => `"${value}"`;
        builder.Append('q', params.query, valueConverterForQuery);
        builder.Append('lang', this.config.lang);
        builder.Append('country', this.config.country);
        return builder.toString();
    }
    callApi(url, params) {
        const urlWithParams = this.buildAutoSuggestionUrl(url, params);
        return super.callApi(urlWithParams, {});
    }
    convertApiResultToUI(data) {
        const result = {};
        const { maxResultsCount } = this.config;
        if (data && data.suggestions) {
            result.autosuggestions = data.suggestions
                .slice(0, maxResultsCount)
                .map(this.mapSuggestionToSearchOption);
        }
        return result;
    }
    // Extended from BaseApi
    createHeaders() {
        return {
            requestId: UtilService_1.UtilService.newUUID(),
        };
    }
}
exports.AutoSuggestionApi = AutoSuggestionApi;
/* tslint:disable */
let Suggestion = class Suggestion {
    constructor() {
        this.term = undefined;
        this.highlightedTerm = undefined;
    }
};
exports.Suggestion = Suggestion;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('term', String),
    tslib_1.__metadata("design:type", String)
], Suggestion.prototype, "term", void 0);
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('highlightedTerm', String, true),
    tslib_1.__metadata("design:type", String)
], Suggestion.prototype, "highlightedTerm", void 0);
exports.Suggestion = Suggestion = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('Suggestion')
], Suggestion);
let SuggestionResult = class SuggestionResult {
    constructor() {
        this.suggestions = undefined;
    }
};
exports.SuggestionResult = SuggestionResult;
tslib_1.__decorate([
    (0, json2typescript_1.JsonProperty)('suggestions', [Suggestion]),
    tslib_1.__metadata("design:type", Array)
], SuggestionResult.prototype, "suggestions", void 0);
exports.SuggestionResult = SuggestionResult = tslib_1.__decorate([
    (0, json2typescript_1.JsonObject)('SuggestionResult')
], SuggestionResult);
/* tslint:enable */
